import * as PopoverPrimitive from '@radix-ui/react-popover';
import { useEffect, useRef, useState, type Ref, type RefObject } from 'react';

export function assignRef<T>(ref: Ref<T> | undefined, node: T | null) {
  if (typeof ref === 'function') ref(node);
  else if (ref) (ref as { current: T | null }).current = node;
}

export function useRejectedFlash() {
  const [reason, setReason] = useState<string | null>(null);
  const timer = useRef<number>();
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const flash = (message: string) => {
    setReason(message);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setReason(null), 2600);
  };
  const settle = () => {
    window.clearTimeout(timer.current);
    setReason(null);
  };
  return { reason, flash, settle };
}

export function RejectionBubble({
  reason,
  anchor,
  onDismiss,
}: {
  reason: string | null;
  anchor: RefObject<HTMLElement>;
  onDismiss: () => void;
}) {
  return (
    <>
      <span role="status" className="sr-only">
        {reason ?? ''}
      </span>
      <PopoverPrimitive.Root open={Boolean(reason)} onOpenChange={(open) => !open && onDismiss()}>
        <PopoverPrimitive.Anchor virtualRef={anchor} />
        <PopoverPrimitive.Portal>
          <PopoverPrimitive.Content
            side="top"
            align="start"
            sideOffset={6}
            collisionPadding={8}
            aria-hidden
            onOpenAutoFocus={(event) => event.preventDefault()}
            onCloseAutoFocus={(event) => event.preventDefault()}
            className="z-[80] max-w-[16rem] rounded-md bg-destructive px-2 py-1 text-xs font-medium text-destructive-foreground shadow-md outline-none animate-in fade-in-0 zoom-in-95 duration-150 no-print"
          >
            {reason}
            <PopoverPrimitive.Arrow className="fill-destructive" width={10} height={5} />
          </PopoverPrimitive.Content>
        </PopoverPrimitive.Portal>
      </PopoverPrimitive.Root>
    </>
  );
}
